export default __webpack_public_path__ + "static/media/registration-page-image.1e6f0978.png";